/* eslint-disable @typescript-eslint/no-explicit-any */
import { DatePicker } from 'antd'
import { requestGetServices, requestGetTreatments } from 'app/api/accounting'
import R from 'app/assets/R'
import { SvgTableCloseIcon } from 'app/assets/svg-assets'
import { DATE } from 'app/common/constants'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { Option } from 'app/components/common/selects/BaseSelect'
import { removeVietnameseTones } from 'app/helpers/string.helper'
import dayjs from 'dayjs'
import _, { isEqual } from 'lodash'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { SearchDropdown } from './search-dropdown'
import * as S from './styles'
export enum PaidTypeTableEnum {
  deposit = 'deposit',
  installment = 'installment',
  one_time_payment = 'one_time_payment',
  no_paid = 'no_paid',
}
export type PaidTypeTableType = keyof typeof PaidTypeTableEnum
const { RangePicker } = DatePicker
declare type EventValue<DateType> = DateType | null
declare type RangeValue<DateType> =
  | [EventValue<DateType>, EventValue<DateType>]
  | null

export interface IFilterBracesTray {
  keyword: string | undefined
  treatments?: string[] | unknown
  services?: string[] | unknown
  paidTypes?: string[] | unknown
  paidType?: string | string[] | unknown
  startDate: string | undefined
  endDate: string | undefined
  search?: string | undefined
  paymentMethod?: string[] | unknown
  serviceType?: string[] | unknown
}

export const FilterBracesTray = ({ handleChangeFilter, filterData }) => {
  const { t } = useTranslation()
  const [filter, setFilter] = useState<IFilterBracesTray>({
    keyword: '',
    treatments: [],
    services: [],
    paidTypes: [],
    paymentMethod: [],
    startDate: dayjs().subtract(4, 'months').format(DATE.YYYY_MM_DD),
    endDate: dayjs().format(DATE.YYYY_MM_DD),
    serviceType: [],
  })

  const [services, setServices] = useState<string[]>([])
  const [isServiceLoading, setIsServiceLoading] = useState<boolean>(false)
  const [treatments, setTreatments] = useState<string[]>([])
  const [isTreatmentLoading, setIsTreatmentLoading] = useState<boolean>(false)
   const treeData = ['Chỉnh nha', 'Implant', 'Sứ']
  const [isOverlayOpen, setOverlayOpen] = useState(false)

  const getTreatments = async () => {
    setIsServiceLoading(true)
    try {
      const response = await requestGetTreatments();
      const names = _.map(response?.data, 'name') as string[];
      setTreatments(names)
    } catch (error) {
      return {
        data: [],
      }
    }

    setIsServiceLoading(false)
  }

  const getServices = async () => {
    setIsTreatmentLoading(true)
    try {
      const response = await requestGetServices()
      const names = _.map(response?.data, 'name') as string[];
      setServices(names)
    } catch (error) {
      return {
        data: [],
      }
    }

    setIsTreatmentLoading(false)
  }

  useEffect(() => {
    getTreatments()
    getServices()
  }, [])

  useEffect(() => {
    handleChangeFilter?.(filter)
  }, [])
  useEffect(() => {
    const timer = setTimeout(() => {
      handleChangeFilter?.(filter)
    }, 500)
    return () => clearTimeout(timer)
  }, [filter])

  useEffect(() => {
    if (filterData && !isEqual(filterData, filter)) {
      setFilter(filterData)
    }
  }, [filterData])

  const onChangeSearch = (search: string) => {
    setFilter(prev => {
      return {
        ...prev,
        search,
      }
    })
  }

  return (
    <S.HeadWrapper gutter={16} align={'middle'}>
      <BaseCol xl={8}>
        <SearchDropdown
          query={filter?.search ?? ''}
          setQuery={onChangeSearch}
          data={[]}
          isOverlayOpen={isOverlayOpen}
          setOverlayOpen={setOverlayOpen}
        />
      </BaseCol>
      <BaseCol xl={8}>
        <BaseFormItem name="select" required={false}>
          <S.SelectBaseStyled
            defaultValue={filter.paidTypes}
            mode="multiple"
            allowClear
            placeholder={t(R.strings.manage_customer_choose_paid_type)}
            suffixIcon={!filter?.paidTypes && <SvgTableCloseIcon />}
            onChange={type =>
              setFilter((prev: IFilterBracesTray) => ({
                ...prev,
                paidTypes: type,
              }))
            }
            filterOption={(value, option) => {
              return removeVietnameseTones(option?.children)
                .toLowerCase()
                .includes(removeVietnameseTones(value).toLowerCase())
            }}
          >
            {Object.values(PaidTypeTableEnum)?.map((item, index) => {
              return (
                <Option value={item} key={index}>
                  {t(item)}
                </Option>
              )
            })}
          </S.SelectBaseStyled>
        </BaseFormItem>
      </BaseCol>
      <BaseCol xl={8}>
        <RangePicker
          style={{
            width: '100%',
          }}
          defaultValue={[dayjs(filter?.startDate), dayjs(filter?.endDate)]}
          value={[dayjs(filter?.startDate), dayjs(filter?.endDate)]}
          onCalendarChange={(date: RangeValue<dayjs.Dayjs>) => {
            if (date && date.length >= 2) {
              setFilter({
                ...filter,
                startDate: date[0] ? date[0].format(DATE.YYYY_MM_DD) : '',
                endDate: date[1] ? date[1].format(DATE.YYYY_MM_DD) : '',
              })
            }
          }}
        />
      </BaseCol>
      <BaseCol xl={8}>
        <BaseFormItem name="select" required={false}>
          <S.SelectBaseStyled
            loading={isTreatmentLoading}
            defaultValue={filter.treatments}
            mode="multiple"
            allowClear
            placeholder={t(R.strings.treatment_label)}
            suffixIcon={!filter?.treatments && <SvgTableCloseIcon />}
            onChange={treatments =>
              setFilter((prev: IFilterBracesTray) => ({
                ...prev,
                treatments,
              }))
            }
            filterOption={(value, option) => {
              return removeVietnameseTones(option?.children)
                .toLowerCase()
                .includes(removeVietnameseTones(value).toLowerCase())
            }}
          >
            {treatments?.map((item, index) => {
              return (
                <Option value={item} key={index}>
                  {t(item)}
                </Option>
              )
            })}
          </S.SelectBaseStyled>
        </BaseFormItem>
      </BaseCol>
      <BaseCol xl={8}>
        <BaseFormItem name="select" required={false}>
          <S.SelectBaseStyled
            loading={isServiceLoading}
            defaultValue={filter.services}
            mode="multiple"
            allowClear
            placeholder={t(R.strings.service_label)}
            suffixIcon={!filter?.services && <SvgTableCloseIcon />}
            onChange={services =>
              setFilter((prev: IFilterBracesTray) => ({
                ...prev,
                services,
              }))
            }
            filterOption={(value, option) => {
              return removeVietnameseTones(option?.children)
                .toLowerCase()
                .includes(removeVietnameseTones(value).toLowerCase())
            }}
          >
            {services?.map((item, index) => {
              return (
                <Option value={item} key={index}>
                  {t(item)}
                </Option>
              )
            })}
          </S.SelectBaseStyled>
        </BaseFormItem>
      </BaseCol>

      <BaseCol xl={8}>
        <BaseFormItem name="select" required={false}>
          <S.SelectBaseStyled
            defaultValue={filter.serviceType}
            mode="multiple"
            allowClear
            placeholder={'Loại dịch vụ'}
            suffixIcon={!filter?.serviceType && <SvgTableCloseIcon />}
            onChange={serviceType =>
              setFilter((prev: IFilterBracesTray) => ({
                ...prev,
                serviceType,
              }))
            }
            filterOption={(value, option) => {
              return removeVietnameseTones(option?.children)
                .toLowerCase()
                .includes(removeVietnameseTones(value).toLowerCase())
            }}
          >
            {treeData?.map((item, index) => {
              return (
                <Option value={item} key={index}>
                  {t(item)}
                </Option>
              )
            })}
          </S.SelectBaseStyled>
        </BaseFormItem>
      </BaseCol>
    </S.HeadWrapper>
  )
}

const BaseFormItem = styled(BaseForm.Item)`
  margin-bottom: 0px !important;
`
